'use strict';

import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

export default function Pagination ({ current=0, total=0, ...props })
{
	const size = props['items-per-page'] || 30;

	const pages_count = parseInt(total / size);

	let pages = [];

	if (total > 0)
	{
		pages.length = total % size > 0
		? pages_count + 1
		: pages_count;
	}

	let rendered_pages = [], additional = 2;

	if (pages.length <= 6) // display all pages
	{
		rendered_pages = Array.from(pages).map((empty, i) => i);
	}
	else
	{
		rendered_pages = getNumbers({ count: pages.length, current, additional });
	}

	rendered_pages = rendered_pages.map(function (number, i)
	{
		const is__active = number === current;

		let output =
		(
			<li className="c-pagination__page" key={ number }>
				<button type="button" disabled={ is__active } className={ 'c-pagination__page-btn' +
					(is__active ? ' active' : '') }
					onClick={ (e) => props.onChange(e, number) }>
					{ number + 1 }
				</button>
			</li>
		);

		if (number > 0 && number < pages.length)
		{
			const miss__prev_page = number-1 > 0 && number+1 < pages.length
			&& rendered_pages.includes(number-1) === false;

			const miss__next_page = number+1 < pages.length && rendered_pages
			.includes(number+1) === false;

			output =
			(
				<Fragment key={ number }>

					{
						miss__prev_page ?
						(
							<li className="c-pagination__suspension">...</li>
						)
						: undefined
					}

					{ output }

					{
						miss__next_page ?
						(
							<li className="c-pagination__suspension">...</li>
						)
						: undefined
					}

				</Fragment>
			);
		}

		return output;
	});

	let infos;

	if (total === 0)
	{
		infos = <span className="c-pagination__infos">Aucun résultat.</span>;
	}
	else if (total <= size)
	{
		infos = <span className="c-pagination__infos">1-{ total }</span>;
	}
	else
	{
		const max = (current + 1) * size;

		infos =
		(
			<span className="c-pagination__infos">
				{ (1 + current * size) + '-' + (max > total ? total : max) }
				{ ' sur ' + total }
			</span>
		);
	}

	const output =
	(
		<div className="c-pagination c-pagination--v2">

			<div className="c-pagination__left" />

			{
				rendered_pages.length > 1 ?
				(
					<ul className="c-pagination__pages">
						{ rendered_pages }
					</ul>
				)
				: undefined
			}

			{ infos }

		</div>
	);

	return output;
}

function getNumbers ({ count, current, additional=2 })
{
	const last_page = count-1;

	let numbers = [0, current, last_page];

// Add one page to the end to bring balance
	if (current === 0)
	{
		numbers.push(current + additional*2 + 1);
	}

// Add one page to the start to bring balance
	if (current === count-1)
	{
		numbers.push(current - additional*2 - 1);
	}

	let left_bonus = 0, right_bonus = 0;

	for (let i = 1; i <= additional; i++)
	{
	// Before the current page
		if (current-i > 0)
		{
			numbers.push(current - i);
		}
		else // Move it after to bring balance
		{
			numbers.push(current + additional + ++right_bonus);
		}

	// After the current page
		if (current+i < last_page)
		{
			numbers.push(current + i);
		}
		else if (current+i >= last_page) // Move it before to bring balance
		{
			numbers.push(current - additional - ++left_bonus);
		}
	}

// Remove duplicates and sort by page
	return numbers.filter(number => number >= 0 && number <= count)
	.reduce(function (pages, number)
	{
		if (pages.includes(number) == false)
		{
			pages.push(number);
		}

		return pages;
	},
	[])
	.sort((a, b) => a > b ? 1 : -1);
}